module.exports = __webpack_public_path__ + "static/img/vue_webpack_logo.85c4531.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vue_webpack_logo.jpeg
// module id = 4hou
// module chunks = 171